import {
  IconBulb,
  IconTrophy,
  IconTrendingUp,
  IconBriefcase,
} from "@tabler/icons-react";
import styles from "./AiInsights.module.css";
import useCountUp, { COUNT_FORMATTERS } from "../../../../hooks/useCountup";

export default function AiStatsShelf({
  overallScore,
  topStrength,
  growthArea,
  roleMatches,
//   data
}) {
  const overallDisplay = useCountUp(
    overallScore,
    1300,
    COUNT_FORMATTERS.percent,
    "mount",
  );
  const rolesDisplay = useCountUp(
    roleMatches,
    1300,
    COUNT_FORMATTERS.int,
    "mount",
  );

//   const skills = data?.flatMap(
//   item => item?.testResult?.skillsAnalysis || []
// ) || [];

// const aiScore = skills.length
//   ? Math.round(
//       skills.reduce((total, skill) => total + (skill.score || 0), 0) /
//       skills.length
//     )
//   : 0;

  return (
    <div className={styles.statShelf}>
      <div className={`${styles.statCard} ${styles.statBlue}`}>
        <div className={styles.statIcon}>
          <IconBulb size={16} />
        </div>
        <div className={styles.statValue}>{overallDisplay}</div>
        <div className={styles.statLabel}>Overall AI Score</div>
      </div>
      <div className={`${styles.statCard} ${styles.statGreen}`}>
        <div className={styles.statIcon}>
          <IconTrophy size={16} />
        </div>
        <div className={styles.statValue}>{topStrength}</div>
        <div className={styles.statLabel}>Top Strength</div>
      </div>
      <div className={`${styles.statCard} ${styles.statAmber}`}>
        <div className={styles.statIcon}>
          <IconTrendingUp size={16} />
        </div>
        <div className={styles.statValue}>{growthArea}</div>
        <div className={styles.statLabel}>Growth Area</div>
      </div>
      <div className={`${styles.statCard} ${styles.statIndigo}`}>
        <div className={styles.statIcon}>
          <IconBriefcase size={16} />
        </div>
        <div className={styles.statValue}>{rolesDisplay}</div>
        <div className={styles.statLabel}>Role Matches</div>
      </div>
    </div>
  );
}
